import i18n from 'shared/i18n';

const LOCALE_MAPPING = {
  'en': 'en-CA',
  'fr': 'fr-CA'
};

const intlLocale = () => LOCALE_MAPPING[i18n.locale] || i18n.locale;

export default intlLocale;
